module.exports = __webpack_public_path__ + "static/celery-1a589ae0636d142503539163acc479a7.svg";